<template>
    <div class="fixed-header">
        <div class="navbar">
            <div class="left_wrap">
                <!-- <img src="../../assets/images/logo.png" alt="" class="img_logo"> -->
                <router-link
                    :to="{ name: 'Home',query: {tid}}"
                    class="welcome"
                    tag="p"
                >
                    HI.欢迎<span :class="{'actived':realname}">{{ realname ? `【${realname}】` :'您' }}</span>来{{ tougaoSetting.organizer }}
                </router-link>
            </div>
            <div
                v-if="realname"
                class="right-menu"
            >
                <el-dropdown
                    class="avatar-container right-menu-item hover-effect"
                    trigger="click"
                >
                    <div class="avatar-wrapper">
                        <img
                            v-if="avatar_url"
                            :src="avatar_url"
                            class="user-avatar"
                        >
                        <svg-icon
                            v-else
                            icon-class="avatar"
                            style="font-size: 40px;"
                        />
                        <i class="el-icon-caret-bottom" />
                    </div>
                    <el-dropdown-menu
                        slot="dropdown"
                        class="user-dropdown"
                    >
                        <el-dropdown-item disabled>
                            <svg-icon icon-class="user" /> {{ realname }}
                        </el-dropdown-item>
                        <router-link
                            :to="{ name: 'My',query: { tid, pkey:'Activities' } }"
                            class="inlineBlock"
                        >
                            <el-dropdown-item>
                                {{ $t('my.activity') }}
                            </el-dropdown-item>
                        </router-link>
                        <router-link
                            :to="{ name: 'My',query: { tid, pkey:'Profile' } }"
                            class="inlineBlock"
                        >
                            <el-dropdown-item>
                                {{ $t('my.personal') }}
                            </el-dropdown-item>
                        </router-link>
                        <router-link
                            :to="{ name: 'My',query: { tid, pkey:'EditPassword' } }"
                            class="inlineBlock"
                        >
                            <el-dropdown-item>
                                {{ $t('login.editPwd') }}
                            </el-dropdown-item>
                        </router-link>
                        <el-dropdown-item>
                            <p @click="handleSetLanguage">{{ change_txt_ }}</p>
                        </el-dropdown-item>
                        <el-dropdown-item divided>
                            <span
                                style="display:block;"
                                @click="logout"
                            >{{ $t('my.logout') }}</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div
                v-else
                class="right-menu right_login"
                @click="toPage('/login')"
            >{{ $t('login.loginIn') }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getTid, setTid } from '@/utils/cookies'

export default {
    data() {
        return {
            tid: this.$route.query.tid ? this.$route.query.tid : getTid()
        }
    },
    computed: {
        ...mapGetters([
            'realname',
            'avatar_url',
            'tougaoSetting'
        ]),
        language() {
            return this.$store.getters.language
        },
        change_txt_() {
            return this.language === 'en' ? 'Switch Chinese' : '切换英文'
        }
    },
    created() {
        this.tid ? setTid(this.tid) : ''
    },
    methods: {
        handleSetLanguage() {
            console.log('in--')
            const lang = this.language === 'zh' ? 'en' : 'zh'
            this.$i18n.locale = lang
            this.$store.dispatch('app/setLanguage', lang)
            this.$message({
                message: 'Switch Language Success',
                type: 'success'
            })
            location.reload()
        },
        logout() {
            this.$confirm('退出后将不能再投稿, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    await this.$store.dispatch('user/logout')
                    this.$router.push({ path: '/login', query: this.$route.query })
                })
                .catch(() => {
                    this.saveLoading = false
                })
        },
        toPage(url) {
            this.$route.path !== url ? this.$router.push({ path: url, query: { tid: this.tid } }) : ''
        }
    }
}
</script>

<style lang="scss" scoped>
.fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: 100%;
    background: #fff;
    -webkit-transition: width 0.28s;
    transition: width 0.28s;
}
.navbar {
    max-width: 1200px;
    height: 80px;
    line-height: 80px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;

    .left_wrap {
        float: left;
        line-height: 80px;
        display: flex;
        align-items: center;

        .img_logo {
            width: 210px;
            height: 30px;
            margin-right: 24px;
        }

        .welcome {
            cursor: pointer;
            font-size: 16px;
            color: #000;

            .actived {
                color: #c72b1e;
            }
        }
    }

    .right_login {
        font-size: 16px;
        color: #666666;
        cursor: pointer;
    }

    .right_login:hover {
        color: $theme_color;
    }

    .right-menu {
        float: right;
        height: 100%;
        line-height: 80px;

        &:focus {
            outline: none;
        }

        .right-menu-item {
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 18px;
            color: #5a5e66;
            vertical-align: text-bottom;

            &.hover-effect {
                cursor: pointer;
                transition: background 0.3s;

                &:hover {
                    background: rgba(0, 0, 0, 0.025);
                }
            }
        }

        .avatar-container {
            margin-right: 30px;

            .avatar-wrapper {
                margin-top: 5px;
                position: relative;

                .user-avatar {
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                }

                .el-icon-caret-bottom {
                    cursor: pointer;
                    position: absolute;
                    right: -20px;
                    top: 25px;
                    font-size: 12px;
                }
            }
        }
    }
}
::v-deep .el-dropdown-menu--mini .el-dropdown-menu__item{text-align:center;}
</style>
